/**
 * custom.js — Turbi store customisations
 *
 * Theme event hooks available:
 *   document.addEventListener('variant:changed', function(event) { var variant = event.detail.variant; });
 *   document.addEventListener('product:added',   function(event) { var variant = event.detail.variant; var quantity = event.detail.quantity; });
 *
 * To force-refresh the mini-cart:
 *   document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
 */

/* ============================================================
   VIDEO POPUP — slideshow trigger buttons
   Replaces the inline jQuery code that was in theme.liquid.
   Works without jQuery using plain DOM APIs.
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {

  function initVideoPopup(triggerSelector, modalId) {
    var trigger = document.querySelector(triggerSelector);
    var modal   = document.getElementById(modalId);
    if (!trigger || !modal) return;

    var iframe = modal.querySelector('iframe');
    var closeBtn = modal.querySelector('.turbi-popup__close');

    // Store the video URL from the trigger's href, then remove href
    var videoUrl = trigger.getAttribute('href');
    if (videoUrl && iframe) {
      iframe.setAttribute('src', videoUrl);
    }
    trigger.removeAttribute('href');

    // Open modal
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    });

    // Close on button click
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeModal(modal, iframe);
      });
    }

    // Close on backdrop click
    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        closeModal(modal, iframe);
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.style.display === 'flex') {
        closeModal(modal, iframe);
      }
    });
  }

  function closeModal(modal, iframe) {
    modal.style.display = 'none';
    document.body.style.overflow = '';
    // Reset iframe src to stop video playback
    if (iframe) {
      var src = iframe.getAttribute('src');
      iframe.setAttribute('src', '');
      iframe.setAttribute('src', src);
    }
  }

  initVideoPopup('.slideshow_first_video',  'popupModalFirst');
  initVideoPopup('.slideshow_second_video', 'popupModalSecond');

});
